// extracted by mini-css-extract-plugin
export var gridStyle = "Grid-module--gridStyle--0ZMb3";